import { useCallback } from 'react';

import { TAttachmentOnClient } from '@entities/attachment/model/types';
import { TCommentType } from '@entities/comment/model/types';
import { useSaveComment } from '@widgets/Comments/api/hooks';
import { getCommentsRequestErrorText } from '@widgets/Comments/lib/helpers';

export const useHandleSave = ({
    positionGuid,
    commentType,
    comment,
    attachedFiles,
    onSuccessCb,
    onErrorCb,
    defaultErrorText,
}: {
    positionGuid: string;
    commentType: TCommentType;
    comment: string;
    attachedFiles: TAttachmentOnClient[];
    onSuccessCb: () => void;
    onErrorCb?: (errorText: string) => void;
    defaultErrorText?: string;
}) => {
    const { mutate: saveComment, isPending } = useSaveComment({
        onSuccess: onSuccessCb,
        onError: (error) => {
            const errorText = getCommentsRequestErrorText(error, defaultErrorText);

            if (errorText) {
                onErrorCb?.(errorText);
            }
        },
    });

    const handleSaveComment = useCallback(() => {
        const normalizedComment = comment.trim();

        if (!normalizedComment && attachedFiles.length === 0) return;

        saveComment({
            positionGuid,
            commentType,
            data: {
                text: normalizedComment,
                attachments: attachedFiles.map(({ file }) => file),
            },
        });
    }, [attachedFiles, comment, positionGuid, commentType, saveComment]);

    return { handleSaveComment, isPending };
};
